import { render, staticRenderFns } from "./table-afm.vue?vue&type=template&id=60fe69a2&scoped=true"
import script from "./table-afm.vue?vue&type=script&lang=js"
export * from "./table-afm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60fe69a2",
  null
  
)

export default component.exports